import React from 'react'

const Label = ({children, className}) => {
    return (
        <h5 className={`font-display tracking-wider uppercase relative pl-4 before:absolute before:top-2.5 before:left-0 before:block before:w-3 before:h-px ${className ? className : ""}`}>{children}</h5>
    )
}

export default Label